module.exports = __webpack_public_path__ + "img/vend-icon.dbf778c9.svg";